export default __webpack_public_path__ + "static/media/visit-logo-white.16c6b68b.svg";